/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cost_Per_MinuteInputs */

const en_cost_per_minute = /** @type {(inputs: Cost_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$1.00 USD per minute`)
};

const fr_cost_per_minute = /** @type {(inputs: Cost_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,00 $ US par minute`)
};

const de_cost_per_minute = /** @type {(inputs: Cost_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,00 USD pro Minute`)
};

const it_cost_per_minute = /** @type {(inputs: Cost_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,00 USD al minuto`)
};

const ru_cost_per_minute = /** @type {(inputs: Cost_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,00 доллар США в минуту`)
};

const es_cost_per_minute = /** @type {(inputs: Cost_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,00 USD por minuto`)
};

const zh_cn2_cost_per_minute = /** @type {(inputs: Cost_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每分钟 1.00 美元`)
};

const ja_cost_per_minute = /** @type {(inputs: Cost_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1分あたり1.00米ドル`)
};

const hi_cost_per_minute = /** @type {(inputs: Cost_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1.00 अमेरिकी डॉलर प्रति मिनट`)
};

const pt_pt2_cost_per_minute = /** @type {(inputs: Cost_Per_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US$ 1,00 por minuto`)
};

/**
* | output |
* | --- |
* | "$1.00 USD per minute" |
*
* @param {Cost_Per_MinuteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cost_per_minute = /** @type {((inputs?: Cost_Per_MinuteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_Per_MinuteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cost_per_minute(inputs)
	if (locale === "de") return de_cost_per_minute(inputs)
	if (locale === "it") return it_cost_per_minute(inputs)
	if (locale === "ru") return ru_cost_per_minute(inputs)
	if (locale === "es") return es_cost_per_minute(inputs)
	if (locale === "zh-CN") return zh_cn2_cost_per_minute(inputs)
	if (locale === "ja") return ja_cost_per_minute(inputs)
	if (locale === "hi") return hi_cost_per_minute(inputs)
	if (locale === "pt-PT") return pt_pt2_cost_per_minute(inputs)
	return en_cost_per_minute(inputs)
});